window.tasksModule.controller 'TasksController', ($scope, $state, $stateParams, $filter, $log, AuthService, TasksService) ->
  $log = $log.getInstance('TasksController', true, false, true)
  $log.log 'Tasks controller loaded.'
